export const roleOptions = [
    { value: "COMPANY", label: "Company" },
    { value: "CELEBRITY_SYSTEM_WORKER", label: "Celebrity Worker" },
    { value: "ADMIN", label: "Admin" },
    { value: "SUPERVISOR", label: "Supervisor" },
    { value: "USER", label: "User" },
  ];
  
  export const roleColors = {
    ADMIN: 'bg-purple-100 text-purple-800',
    COMPANY: 'bg-blue-100 text-blue-800',
    CELEBRITY_SYSTEM_WORKER: 'bg-yellow-100 text-yellow-800',
    SUPERVISOR: 'bg-orange-100 text-orange-800',
    USER: 'bg-green-100 text-green-800'
  };